import styled from 'styled-components';
import { borderRadius, colourPalette, fontSize, lineHeight } from 'styles/styles';

export const LeftPanelPageBaseLeftComponentItemStyle = {
  Container: styled.div`
    display: flex;
    gap: 12px;
    max-width: 550px;
    width: 100%;
    margin-bottom: 40px;
  `,
  IconBox: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colourPalette.neutral900};
    height: 26px;
    width: 26px;
    border-radius: ${borderRadius.roundedFull};
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  Title: styled.h4`
    margin: 0;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: ${colourPalette.neutral0};
  `,
  Description: styled.p`
    margin: 0;
    font-weight: 400;
    font-size: ${fontSize.fontSizeSM};
    line-height: ${lineHeight.lineHeightMD};
    color: ${colourPalette.neutral300};
  `,
};
